import { IFooterMenuItem, ILegalLinks, ISocialIconProps } from '@web_opxp/components';
import { urlPool } from '@web_opxp/features';
import { ELanguage, LanguageService } from '@web_opxp/language';
import { HistoryService } from 'web_core_library';
import { AssetsBaseUrl, AuthBaseUrl } from './env';
import { EBlogUrls, getBlogPage } from './utils';

export function getFooterMenu(session?: string) {
  const t = LanguageService.getTFunction();
  const language = LanguageService.getLanguage();

  const footerMenuItems: IFooterMenuItem[] = [
    {
      title: t('common.common:Footer.Menu.Effectiveness'),
      link: language ? HistoryService.getEffectivenessUrl(language) : '',
    },
    {
      title: t('common.common:Footer.Menu.Help'),
      link: language ? urlPool.getZendeskUrl(language, session) : '',
    },
    {
      title: t('common.common:Footer.Menu.Blog'),
      link: language ? HistoryService.getBlogUrl(language) : '',
    },
  ];

  if (language === ELanguage.English || language === ELanguage.German) {
    footerMenuItems.push({
      title: t('common.common:Footer.Menu.Jobs'),
      link: language ? HistoryService.getJobsUrl() : '',
      target: '_blank',
    });
  }

  if (language === ELanguage.German) {
    footerMenuItems.push({
      title: t('common.common:Footer.Menu.GroupPackage'),
      link: language ? HistoryService.getInternalUrl('/lp/corp').toString() : '',
    });
  }

  const extraMenuItems: IFooterMenuItem[] = [
    {
      title: t('common.common:Footer.Menu.Extra1'),
      link: language ? getBlogPage(language, EBlogUrls.Extra1) : '',
    },
    {
      title: t('common.common:Footer.Menu.Extra2'),
      link: language ? getBlogPage(language, EBlogUrls.Extra2) : '',
    },
    {
      title: t('common.common:Footer.Menu.Extra3'),
      link: language ? getBlogPage(language, EBlogUrls.Extra3) : '',
    },
    {
      title: t('common.common:Footer.Menu.Extra4'),
      link: language ? getBlogPage(language, EBlogUrls.Extra4) : '',
    },
    {
      title: t('common.common:Footer.Menu.Extra5'),
      link: language ? getBlogPage(language, EBlogUrls.Extra5) : '',
    },
  ];

  return [footerMenuItems, extraMenuItems];
}

export function getFooterSocialItems(hideMobile = false) {
  const t = LanguageService.getTFunction();
  const getLink = (fileName: string) => `${AssetsBaseUrl}/feature/icons/${fileName}`;

  const socialBarItems: ISocialIconProps[] = [
    {
      title: t('common.common:Footer.Social.Facebook'),
      link: 'https://www.facebook.com/NeuroNation/',
      iconSrc: getLink('si-01.png'),
    },
    {
      title: t('common.common:Footer.Social.Twitter'),
      link: 'https://www.twitter.com/NeuroNation/',
      iconSrc: getLink('si-02.png'),
    },
  ];
  if (!hideMobile) {
    socialBarItems.push({
      title: t('common.common:Footer.Social.Apple'),
      link: 'https://app.adjust.com/pa7bvk?campaign=organic',
      iconSrc: getLink('si-03.png'),
    });
    socialBarItems.push({
      title: t('common.common:Footer.Social.Android'),
      link: 'https://app.adjust.com/pa7bvk?campaign=organic',
      iconSrc: getLink('si-04.png'),
    });
  }
  return socialBarItems;
}

export function getLegalLinks() {
  const t = LanguageService.getTFunction();
  const language = LanguageService.getLanguage();
  const touTitle = t('common.common:Footer.Legals.Tou');
  const touSrc = `${AuthBaseUrl}/legals/tou/?lang=${language}&theme=opxp`;
  const policyTitle = t('common.common:Footer.Legals.Privacy');
  const policySrc = `${AuthBaseUrl}/legals/dataprivacy/?lang=${language}&theme=opxp`;
  const imprintTitle = t('common.common:Footer.Legals.Impressum');
  const imprintSrc = `${AuthBaseUrl}/legals/imprint/?lang=${language}&theme=opxp`;
  const legalLinks: ILegalLinks = {
    imprint: { title: imprintTitle, src: imprintSrc },
    policy: { title: policyTitle, src: policySrc },
    tou: { title: touTitle, src: touSrc },
  };
  return legalLinks;
}
